import { ReactNode, useEffect, useState } from 'react';

export type IntervalRendererProps = {
  children: () => ReactNode;
  interval?: number;
};

/**
 * A component that re-renders itself automatically.
 * Useful for "elapsed time" etc.
 * The `children` shall be a render function that
 * will be called repetitively every `interval` (in milliseconds).
 */
const IntervalRenderer = ({
  children,
  interval = 1000,
}: IntervalRendererProps) => {
  const [, rerender] = useState({});

  useEffect(() => {
    let isMounted = true;
    const timer = setInterval(() => {
      if (isMounted) {
        rerender({});
      }
    }, interval);

    // Clear interval on unmount
    return () => {
      isMounted = false;
      clearInterval(timer);
    };
  }, [interval]);

  // The children() is wrapped with a fragment for type checking
  return <>{children?.() ?? null}</>;
};

// eslint-disable-next-line import/no-default-export
export default IntervalRenderer;
